// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_item {
  color: #f4ece1 !important;
  border-radius: 10px;
  margin: 10px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
}
.card_item .main_row {
  width: 100%;
  display: flex;
  margin: 10px 0px;
  justify-content: space-between;
}
.card_item__info {
  width: 50%;
  padding: 15px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
.card_item__info h3 {
  font-size: 24px;
  text-transform: uppercase;
}
.card_item__info p {
  font-size: 12px;
}
.card_item__info .block_item {
  display: flex;
  align-items: center;
}
.card_item__info .block_item ion-icon {
  margin-right: 5px;
}
.card_item__info .block_item p {
  font-size: 10px;
  color: var(--ion-color-primary);
}
.card_item__info ion-button {
  max-height: 32px;
  font-size: 12px;
  --border-radius: 28px;
  width: 100px;
  border-radius: 28px;
}
.card_item__image {
  width: 49%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/loyalty-items-render/loyalty-items-render.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EAEA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;AAAJ;AAKI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AAHR;AAKI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;AAHR;AAIQ;EACI,eAAA;EACA,yBAAA;AAFZ;AAIQ;EACI,eAAA;AAFZ;AAIQ;EACI,aAAA;EACA,mBAAA;AAFZ;AAGY;EACI,iBAAA;AADhB;AAGY;EACI,eAAA;EACA,+BAAA;AADhB;AAIQ;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AAFZ;AAKI;EACI,UAAA;AAHR","sourcesContent":[".card_item {\n    color: #f4ece1 !important;\n\n    border-radius: 10px;\n    margin: 10px 20px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    overflow: hidden;\n    // opacity: 0.5;\n    &.active {\n        // opacity: 1;\n    }\n    .main_row {\n        width: 100%;\n        display: flex;\n        margin: 10px 0px;\n        justify-content: space-between;\n    }\n    &__info {\n        width: 50%;\n        padding: 15px 10px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: flex-start;\n        h3 {\n            font-size: 24px;\n            text-transform: uppercase;\n        }\n        p {\n            font-size: 12px;\n        }\n        .block_item {\n            display: flex;\n            align-items: center;\n            ion-icon {\n                margin-right: 5px;\n            }\n            p {\n                font-size: 10px;\n                color: var(--ion-color-primary);\n            }\n        }\n        ion-button {\n            max-height: 32px;\n            font-size: 12px;\n            --border-radius: 28px;\n            width: 100px;\n            border-radius: 28px;\n        }\n    }\n    &__image {\n        width: 49%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
